export enum TeamMemberListType {
  General,
  ShipmentOrder,
  Invoice,
  Onboarding,
  ThirdParty,
}
